<template>
  <div class="col-xs-12 col-sm-8 col-sm-offset-2 chat">
    <form class="profile" v-on:submit.prevent="saveProfile">
      <div class="form-group">
        <label for="name">Name</label>
        <input type="text" class="form-control" v-model="profile.name" id="name">
      </div>
      <div class="form-group">
        <label for="age">Age</label>
        <input type="number" class="form-control" v-model="profile.age"  id="age">
      </div>
      <div class="form-group">
        <label for="location">Location</label>
        <input type="text" class="form-control" v-model="profile.location" id="location">
      </div>
      <div class="form-group">
        <label for="gender">Gender</label>
        <select class="form-control" id="gender" v-model="profile.gender">
          <option value="">--Select Gender--</option>
          <option value="woman" :selected="profile.gender === 'woman' ? 'selected' : ''">Female</option>
          <option value="man" :selected="profile.gender === 'man' ? 'selected' : ''">Male</option>
        </select>
      </div>
      <!-- <div class="form-group">
        <label for="laguage">Language</label>
        <select class="form-control" id="language" v-model="profile.language">
          <option value="">--Select Language--</option>
          <option value="eng">English</option>
          <option value="swa">Swahili</option>
        </select>
      </div> -->
      <div class="form-group">
        <label for="laguage">Language </label>        
        <select class="form-control" id="language" v-model="profile.language">
          <option  value="">--Select Language--</option>          
           <option v-for="(lang, index) in supportedLanguages" :key="index" :value="lang.alias" :selected="profile.language === lang.alias ? 'selected' : ''">{{ lang.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="married">Married</label>
        <select class="form-control" id="married" v-model="profile.married">
          <option value="">--Select marital status--</option>
          <option value="true" :selected="profile.married === true ? 'selected' : ''">Yes</option>
          <option value="false" :selected="profile.married === false ? 'selected' : ''">No</option>
        </select>
      </div>
      <div class="form-group">
        <label for="has-kids">Has Kids</label>
        <select class="form-control" id="has-kids" v-model="profile.hadkids">
          <option value="">--Select--</option>
          <option value="true" :selected="profile.hadkids === true ? 'selected' : ''">Yes</option>
          <option value="false" :selected="profile.hadkids === false ? 'selected' : ''">No</option>
        </select>
      </div>

      <div v-if="profile.referrals.length" class="form-group">
        <label for="location">Referral Code</label>
        <input type="text" class="form-control" :value="profile.referrals[profile.referrals.length - 1].code" readonly>
      </div>

      <div v-if="profile.referrals.length" class="form-group">
        <label for="location">Referral Date</label>
        <input type="text" class="form-control" :value="formatDate(profile.referrals[profile.referrals.length - 1].dt)" readonly>
      </div>

      <div v-if="profile.referrals.length && profile.referrals[profile.referrals.length - 1].redemptionat" class="form-group">
        <label for="location">Redemption Date</label>
        <input type="text" class="form-control" :value="formatDate(profile.referrals[profile.referrals.length - 1].redemptionat)" readonly>
      </div>

      <div v-if="profile.feedback.length" class="form-group">
        <label for="location">Feedback Completion Date</label>
        <input type="text" class="form-control" :value="formatDate(profile.feedback[profile.feedback.length - 1].dt)" readonly>
      </div>

      <div v-if="!profile.screening" class="form-group">
        <label for="location">Has not started screening</label>
        <input type="text" class="form-control" :value="true" readonly>
      </div>

      <div v-if="profile.screening && !profile.screening.result" class="form-group">
        <label for="location">Has failed screening</label>
        <input type="text" class="form-control" :value="(profile.screening && !profile.screening.result)" readonly>
      </div>

      <button type="submit" class="btn btn-primary" :disabled="isSaving">{{isSaving ? 'Saving' : 'Save'}}</button>
      <button type="button" class="btn btn-danger" v-on:click="hideProfile()">Cancel</button>
    </form>
  </div>
</template>
<script>
  import moment from 'moment-timezone';
  import { mapActions } from 'vuex';

  export default {
    name: 'app-profile',
    methods: {
      hideProfile() {
        this.$emit('close');
      },

      formatDate(timestamp) {
        return moment.unix(timestamp).format('YYYY-MM-DD');
      },

      async saveProfile() {
        this.isSaving = true;
        try {
          const { status, data } = await this.saveProfileAction(this.profile);
          this.$emit('show', data.payload, status === 200 ? 'success' : 'error');
          if (status === 200) {
            this.$emit('close');
          }
        } catch (error) {
          this.$emit('show', 'Please check your internet connection', 'error');
        } finally {
          this.isSaving = false;
        }
      },
      ...mapActions(['saveProfileAction'])
    },
    props: ['profile', 'supportedLanguages'],
    data() {
      return {
        isSaving: false
      };
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/chat/profile.vue